import { useState } from 'react';
import { FormControl, Stack } from '@chakra-ui/react';
import { Field } from 'formik';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import { FormLabel } from '@/components/v4';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const CountryAlpha3Field = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.alpha3 && touched.alpha3}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>Alpha-3</FormLabel>
                <Field
                    name="alpha3"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            pl={2}
                            placeholder="Please enter a Alpha-3"
                            onKeyPress={(event) => {
                                const currentInput =
                                    event.target.value + event.key;
                                if (
                                    !/^[A-Z]$/.test(event.key) ||
                                    currentInput.length > 3
                                ) {
                                    event.preventDefault();
                                }
                            }}
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="eg. USA"
                        ariaLabel="country-alpha3-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError isDrawer={false}>{errors?.alpha3}</FieldError>
        </FormControl>
    );
};

export default CountryAlpha3Field;
